<div *ngIf="!componentLoaded"><mat-spinner diameter="30" strokeWidth="5"></mat-spinner> Loading Component</div>